module.exports = __webpack_public_path__ + "media/virtualStaging/galleryImage1-f0767bad.jpeg";